import React, {memo, useState} from 'react'
import cx from 'classnames'

/* Styles */
import s from './popular-keyword.scss'

const displayedItemLimit = 9

const PopularKeyword = memo(({className, keywords, isBot}) => {
  const [hideExtras, setHideExtras] = useState(true)
  return (
    <section className={cx(className, s.root)}>
      <div className={s.title}>{'Popüler Aramalar'}</div>
      <div
        className={cx(s.keywords, {[s.closedKeywords]: hideExtras})}
        data-test-id='popular-keyword-items'>
        {
          keywords?.map(({keyword, url}, index) => (
            <a key={index} href={url} title={keyword} className={s.keyword}>
              <span>{keyword}</span>
            </a>
          ))
        }
      </div>
      {
        keywords?.length > displayedItemLimit && (
          <div className={s.showHideAllButtonWrapper}>
            <button
              onClick={() => setHideExtras((state) => !state)}
              className={s.showHideAllButton}>
              <span>{hideExtras ? 'Tümünü Gör' : 'Kapat'}</span>
              <i
                className={cx(s.arrowIcon, {
                  [s.arrowIconUpsideDown]: !hideExtras,
                })}/>
            </button>
          </div>
        )
      }
    </section>
  )
})

export default PopularKeyword
